<template>
  <div id="information" class="main">
    <MeetingSummary mode="def" v-if="isPermission('OwnedNonResident')" />

    <InfoList />

    <section class="main-section kanri-lv1" v-if="isPermission('Chairman')">
      <div class="btn_kanri">
        <router-link to="/admin/information"
          >お知らせ管理</router-link
        >
      </div>
    </section>
    <!--/.main-section-->
    <IconMenu />
  </div>
</template>

<script>
import InfoList from "@/components/InfoList.vue";
import MeetingSummary from "@/components/MeetingSummary.vue";
import IconMenu from "@/components/IconMenu.vue";
export default {
  components: { InfoList, MeetingSummary, IconMenu },
};
</script>

<style></style>
